//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Pod.WebControls.PrideleneListPage.ts                 </Name>
//    <Description>                                                             </Description>
//    <Author>      Jiří Šindelka                                               </Author>
//    <Copyright>   © GORDIC spol. s r. o. 1993-2021                            </Copyright>
//    <Created>     2021-01-04                                                  </Created>
//  </FileHeader>

namespace Gordic.Pod.Lists
{
    @Decorators.gcontent
    export class PrideleneListPage extends GContentBase<PodDokSpisListBasePage>
    {
        model: Wfl.Interface.GPrideleneFilterDto;

        onContentReady() {
            const that = this;
            PodDokSpisListBasePage.InitList(this);
            //this.topActions.push(Wfl.ListAC.WflListBaseAC.CreateActionDetailDokSpis(this));
            this.specialActions.push(Wfl.ListAC.DokSpisListBaseAC.CreateActionPridelit(this, true));
            this.specialActions.push(PodDokSpisListBasePage.CreateActionOpravaElPodani(this, true));
            this.specialActions.push(PodDokSpisListBasePage.CreateActionVratitPoste(this, true));
            this.specialActions.push(PodDokSpisListBasePage.CreateActionStornovat(this));
            this.specialActions.push(Gordic.Wfl.ListAC.DokSpisListBaseAC.CreateActionZrusitPrideleni(this, true));
            Gordic.Wfl.ListAC.WflListBaseAC.CompleteMenu(this);

            // samotná definice gfilterpanelu
            this.filterForm = $("<div>")
                .appendTo(this.element)
                .on("gfilterpanelapply", function (event, obj) {         // eventa která je vyvolána při vyhledávání. obj.filter -> hledaný seznam podmínek
                    that.LoadData(obj.filter);
                }).gfilterpanel({
                    forms: this.CreateFilterForms(), // poleFormu ktere budou pouzity pro podminky
                    favorites: "all", 
                    filterStorageService: new Gordic.Gin.FilterStorageService.Store({ tema: "pod_ptm_dspreo" }),
                    favoriteLayoutDescriptor: Gordic.Gin.Globals.Enums.LayoutDescriptorType.list,
                    poVyhledaniZobrazit: "OblibenePodminky"
                })

            this.gridSearchColumns = ["*", "dat_zmena"];
            Wfl.ListAC.DokSpisListBaseAC.CreateGridDokSpis(this);
            this.filterForm.gfilterpanel("applyFilter", this.model, !this.NacistSeznamPriOtevreni);
        }

        CreateFilterForms() {
            var filterForm = new Gordic.Forms.Form({ name: "FormDocsList", tabLabel: "", layoutDescriptor: "L2M2S1, L-3-8-1, M-12-11-1, S-12-11-1, breaks-700-1000" }); //RC 26285623 : Filtr balíků
            filterForm.addSection().addRow({ layoutDescriptor: "w-6" }).addField("gcheck", { name: "Vlastni", label: "jres:23900106", initialValue: this.model.Vlastni  }); //RC 23900106 : Vlastní
            filterForm.addRow({ label: "" }).addField("gradio", {
                name: "TypZobrazeni", itemClass: "",
                //model: "model.TypZobrazeni=value.TypZobrazeni",
                initialValue: this.model.TypZobrazeni,
                radios: [
                    { value: Wfl.Interface.TypSeznamuPridelenych.Neurceno, label: 'jres:23900115' }, //RC 23900115 : Vše
                    { value: Wfl.Interface.TypSeznamuPridelenych.NovaPosta, label: 'jres:23900107' }, //RC 23900107 : Nová pošta
                    { value: Wfl.Interface.TypSeznamuPridelenych.Redistribuce, label: 'jres:31950092' }, //RC 31950092 : Redistribuce

                ],
                change: function (event, input) {
                    //if (input.value) {
                    //    if (that.defaultForm) {
                    //        that.defaultForm.findFields(fieldNames.referent).gfield("option", "disabled", input.value != 1);
                    //        that.defaultForm.findFields(fieldNames.extSubject).gfield("option", "disabled", input.value == 1);
                    //    }
                    //}
                }
            });
            return [filterForm];
        }

        LoadData(filtr?: Wfl.Interface.GPrideleneFilterDto) {
            var that = this;
            Gin.Globals.ShowWaitLoadData(this);
            //nacteni dat do gridu
            this.call<Wfl.Interface.DokSpisListDto[]>("LoadData", { "model": filtr })
                .done(function (data) {
                    var view = new Gordic.Data.View(data, { key: that.IDPrimaryKeyGridu });  //key je dulezity kvuli pripadnemu vyhledavani radku
                    that.mainGrid.ggrid("setData", view);
                })
                .always(function () { Gordic.Wfl.ListAC.WflListBaseAC.AfterLoadData(that); });
        }

        ReloadData() {
            this.LoadData(this.model);
        }
    }
};
